module.exports = __webpack_public_path__ + "static/media/recs-alt-bg.e48419b2.jpg";